/**
 * Checks if the window object is defined.
 * @returns A boolean indicating whether the window object is defined.
 */
export function isWindowDefined(): boolean {
  return typeof window !== 'undefined';
}
